// «الصيانة» test ids (E2E suite later, branch `e2e`).
export const MAINT = {
    page: "maint-page",
    syncLine: "maint-sync-line",
    syncState: "maint-sync-state",
    syncAuto: "maint-sync-auto",
    autoSync: "maint-auto-sync",
    runBtn: "maint-run-now",
    notConfigured: "maint-not-configured",
    syncError: "maint-sync-error",
    truncated: "maint-truncated",
    dateFrom: "maint-date-from",
    dateTo: "maint-date-to",
    preset: (k) => `maint-preset-${k}`,
    kpis: "maint-kpis",
    kpi: (k) => `maint-kpi-${k}`,
    branchTable: "maint-branch-table",
    branchCol: (k) => `maint-branch-col-${k}`,
    branchRow: (id) => `maint-branch-row-${id}`,
    branchCell: (id, k) => `maint-branch-${id}-${k}`,
    suggestedBadge: "maint-suggested-badge",
    unmappedBadge: "maint-unmapped-badge",
    technicians: "maint-technicians",
    techRow: (id) => `maint-tech-${id}`,
    lists: "maint-lists",
    listTab: (k) => `maint-list-tab-${k}`,
    filter: (k) => `maint-filter-${k}`,
    overdueToggle: "maint-filter-overdue",
    listRow: (type, id) => `maint-item-${type}-${id}`,
    listEmpty: "maint-list-empty",
    listMore: "maint-list-more",
    pagePrev: "maint-page-prev",
    pageNext: "maint-page-next",
    itemSheet: "maint-item-sheet",
    itemField: (k) => `maint-item-field-${k}`,
    itemTimeline: "maint-item-timeline",
    itemParts: "maint-item-parts",
    itemPhotos: (k) => `maint-item-photos-${k}`,
    itemPhoto: "maint-item-photo",
    itemPhotoBroken: "maint-item-photo-broken",
    itemPhotosSection: "maint-photos-section",
    itemPhotosUnavailable: "maint-photos-unavailable",
    itemPhotosSomeUnavailable: "maint-photos-some-unavailable",
    itemPhotosOpenLink: "maint-photos-open-maint",
    itemOpenLink: "maint-item-open-maint",
    itemClose: "maint-item-close",
    branchSheet: "maint-branch-sheet",
    branchKpi: (k) => `maint-branch-kpi-${k}`,
    branchMonths: "maint-branch-months",
    branchRepeats: "maint-branch-repeats",
    branchShowItems: "maint-branch-show-items",
    mapping: "maint-mapping",
    mappingRow: (code) => `maint-mapping-${code}`,
    mappingSelect: (code) => `maint-mapping-select-${code}`,
    mappingSave: "maint-mapping-save",
    mappingConfirmAll: "maint-mapping-confirm-all",
    mappingEmpty: "maint-mapping-empty",
    empty: "maint-empty",
};
